export const circleStroke = function(ctx: any) {
  ctx.save();
  ctx.strokeStyle = "rgba(0,0,0,0)";
  ctx.miterLimit = 4; 
  ctx.save();
  ctx.beginPath();
  ctx.moveTo(100.5, 196);
  ctx.bezierCurveTo(47.84, 196, 5, 153.16, 5, 100.5);
  ctx.bezierCurveTo(5, 47.84, 47.84, 5, 100.5, 5);
  ctx.bezierCurveTo(153.16, 5, 196, 47.84, 196, 100.5);
  ctx.bezierCurveTo(196, 153.16, 153.16, 196, 100.5, 196);
  ctx.closePath();
  ctx.moveTo(100.5, 19);
  ctx.bezierCurveTo(55.56, 19, 19, 55.56, 19, 100.5);
  ctx.bezierCurveTo(19, 145.44, 55.56, 182, 100.5, 182);
  ctx.bezierCurveTo(145.44, 182, 182, 145.44, 182, 100.5);
  ctx.bezierCurveTo(182, 55.56, 145.44, 19, 100.5, 19);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.restore();
  ctx.restore();
};
